// extracted by mini-css-extract-plugin
export default {"PeriodStart":"PeriodYears-module_PeriodStart_FNCUk","PeriodEnd":"PeriodYears-module_PeriodEnd_i3Wmb"};